// Scenario 3b: past_due_us_red
// Same as past_due_us but pastDueSince = now - 6d.
// daysRemaining = 1 -> red severity (#06).

import { pastDueUs } from './past-due-us.fixture';
import { Scenario, daysFromNow } from './scenario.types';

export const pastDueUsRed: Scenario = {
  ...pastDueUs,
  name: 'past_due_us_red',
  subscription: pastDueUs.subscription
    ? {
        ...pastDueUs.subscription,
        id: 'sub_past_due_us_red',
        pastDueSince: daysFromNow(-6),
        gracePeriodEndsAt: daysFromNow(1)
      }
    : null
};
